import { FormItemsGroup, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'

import { PhoneNumber } from '../PhoneNumber'
import { EmailAddress } from './elements/EmailAddress'
import { FirstName } from './elements/FirstName'
import { LastName } from './elements/LastName'

export const ContactInfo = (): ReactElement => {
  return (
    <FormItemsGroup rowSpacing={Spacing.S12}>
      <FormItemsGroup itemsInRow={2}>
        <FirstName />
        <LastName />
      </FormItemsGroup>
      <EmailAddress />
      <PhoneNumber />
    </FormItemsGroup>
  )
}
